import { IssueTemplateDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

type GetIssueTemplateParams = {
  slug: string | undefined;
  issueTypeId?: string;
  issueSubtypeId?: string;
};

export function useIssueTemplate({
  slug,
  issueTypeId,
  issueSubtypeId,
}: GetIssueTemplateParams) {
  const api = useApi();
  return useQuery<IssueTemplateDto, ExtendedAxiosError>({
    queryKey: ['issue-templates', slug],
    queryFn: () =>
      api.issueTemplatesApi
        .getIssueTemplate(slug!, issueTypeId!, issueSubtypeId || '')
        .then((r) => r.data),
    enabled: !!slug && !!issueTypeId,
  });
}
